export const validateField = (field, value) => {
  switch (field) {
    case "primerApellido":
    case "segundoApellido":
    case "nombres": {
      if (!value) return { isValid: false, message: "Campo requerido" };
      const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/;
      if (!regex.test(value)) return { isValid: false, message: "Solo letras y espacios" };
      if (value.trim().length < 3) return { isValid: false, message: "Debe tener al menos 3 caracteres" };
      return { isValid: true, message: "" };
    }

    case "genero":
      return value ? { isValid: true, message: "" } : { isValid: false, message: "Campo requerido" };

    case "codigoPostal":
      if (!value) return { isValid: false, message: "Campo requerido" };
      if (!/^\d{5}$/.test(value)) return { isValid: false, message: "Debe tener 5 dígitos" };
      return { isValid: true, message: "" };

    default:
      return { isValid: true, message: "" };
  }
};